import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Location } from '../../entities/location/location';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

@Injectable()
export class LocationService {
  constructor(private apolloService: ApolloService) {}

  public getLocations(): Observable<Location[]> {
    return this.apolloService
      .query<fromGraphQl.GetLocationsResponse>(fromGraphQl.GET_LOCATIONS_QUERY)
      .pipe(
        take(1),
        switchMap((result) => of(Location.createLocations(result.data.getLocations)))
      );
  }
}
